// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  border: none;
  outline: none;
  font-family: "Inter";
  font-weight: 500;
  display: flex;
  grid-gap: 8px;
  align-items: center;
  justify-content: center;
}
.button a:link,
.button a:hover,
.button a:visited,
.button a:active {
  text-decoration: none;
  color: unset;
  display: flex;
  grid-gap: 8px;
}
.button--primary {
  padding: 26px 1rem;
  border-radius: 60px;
  background-color: #1F106D;
  color: #fbfbfb;
  font-size: 16px;
  font-weight: 600;
}
@media all and (min-width: 1280px) {
  .button--primary {
    font-size: 18px;
  }
}
@media all and (hover: hover) {
  .button--primary:hover {
    transition-duration: 250ms;
    cursor: pointer;
    background-color: #331CAA;
  }
  .button--primary:active {
    transition-duration: 0ms;
    background-color: #011C5A;
  }
}
.button--secondary {
  border: 2px solid #1f48b1;
  color: #1f48b1;
  background-color: #fbfbfb;
  border-radius: 32px;
  width: 100%;
  padding: 20px 40px;
  font-size: 16px;
}
@media all and (min-width: 1280px) {
  .button--secondary {
    font-size: 18px;
  }
}
@media all and (hover: hover) {
  .button--secondary:hover {
    transition-duration: 250ms;
    cursor: pointer;
    opacity: 0.5;
  }
  .button--secondary:active {
    transition-duration: 0ms;
    background-color: #011C5A;
  }
}
.button--tertiary {
  background-color: #1f48b1;
  color: #fbfbfb;
  border-radius: 32px;
  width: 100%;
  padding: 20px 40px;
  font-size: 16px;
}
@media all and (min-width: 1280px) {
  .button--tertiary {
    font-size: 18px;
  }
}
@media all and (hover: hover) {
  .button--tertiary:hover {
    transition-duration: 250ms;
    cursor: pointer;
    background-color: #011C5A;
  }
  .button--tertiary:active {
    transition-duration: 0ms;
    background-color: #011C5A;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAGE;;;;EAIE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AADJ;AAIE;EACE,kBAAA;EACA,mBAAA;EACA,yBCjBa;EDkBb,cCOQ;EDNR,eAAA;EACA,gBAAA;AAFJ;AAII;EARF;IASI,eAAA;EADJ;AACF;AAGI;EACE;IACE,0BAAA;IACA,eAAA;IACA,yBC1BU;EDyBhB;EAII;IACE,wBAAA;IACA,yBC9BY;ED4BlB;AACF;AAME;EACE,yBAAA;EACA,cCzCgB;ED2ChB,yBCnBQ;EDqBR,mBAAA;EACA,WAAA;EAEA,kBAAA;EACA,eAAA;AAPJ;AASI;EAZF;IAaI,eAAA;EANJ;AACF;AAQI;EACE;IACE,0BAAA;IACA,eAAA;IACA,YAAA;EANN;EAWI;IACE,wBAAA;IACA,yBC9DY;EDqDlB;AACF;AAaE;EACE,yBCxEgB;EDyEhB,cCjDQ;EDmDR,mBAAA;EACA,WAAA;EAEA,kBAAA;EACA,eAAA;AAbJ;AAeI;EAVF;IAYI,eAAA;EAbJ;AACF;AAeI;EACE;IACE,0BAAA;IACA,eAAA;IACA,yBCtFY;EDyElB;EAgBI;IACE,wBAAA;IACA,yBC3FY;ED6ElB;AACF","sourcesContent":["@import \"src/styles/variables\";\n\n.button {\n  border: none;\n  outline: none;\n  font-family: \"Inter\";\n  font-weight: 500;\n  display: flex;\n  grid-gap: 8px;\n  align-items: center;\n  justify-content: center;\n\n  a:link,\n  a:hover,\n  a:visited,\n  a:active {\n    text-decoration: none;\n    color: unset;\n    display: flex;\n    grid-gap: 8px;\n  }\n\n  &--primary {\n    padding: 26px 1rem;\n    border-radius: 60px;\n    background-color: $main-dark-blue;\n    color: $white-100;\n    font-size: 16px;\n    font-weight: 600;\n\n    @media all and (min-width: $desktop) {\n      font-size: 18px;\n    }\n\n    @media all and (hover: hover) {\n      &:hover {\n        transition-duration: 250ms;\n        cursor: pointer;\n        background-color: $hover-main-blue;\n      }\n\n      &:active {\n        transition-duration: 0ms;\n        background-color: $pressed-main-blue;\n      }\n    }\n  }\n\n  &--secondary {\n    border: 2px solid $main-mid-blue-100;\n    color: $main-mid-blue-100;\n\n    background-color: $white-100;\n\n    border-radius: 32px;\n    width: 100%;\n\n    padding: 20px 40px;\n    font-size: 16px;\n\n    @media all and (min-width: $desktop) {\n      font-size: 18px;\n    }\n\n    @media all and (hover: hover) {\n      &:hover {\n        transition-duration: 250ms;\n        cursor: pointer;\n        opacity: 0.5;\n        //border: 2px solid $main-light-blue;\n        //color: $main-light-blue;\n      }\n\n      &:active {\n        transition-duration: 0ms;\n        background-color: $pressed-main-blue;\n      }\n    }\n  }\n\n  &--tertiary {\n    background-color: $main-mid-blue-100;\n    color: $white-100;\n\n    border-radius: 32px;\n    width: 100%;\n\n    padding: 20px 40px;\n    font-size: 16px;\n\n    @media all and (min-width: $desktop) {\n      //padding: 20px 90px;\n      font-size: 18px;\n    }\n\n    @media all and (hover: hover) {\n      &:hover {\n        transition-duration: 250ms;\n        cursor: pointer;\n        background-color: $pressed-main-blue;\n      }\n\n      &:active {\n        transition-duration: 0ms;\n        background-color: $pressed-main-blue;\n      }\n    }\n  }\n}\n","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
